import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Avatar from "@material-ui/core/Avatar";

import useServiceWorker from "../../hooks/service-worker";

const useStyles = makeStyles(theme => ({
  closeBtn: {
    padding: "0",
    height: "22px",
    width: "22px"
  },
  closeIcon: {
    fontSize: "22px",
    color: "#4e4e4e",
    lineHeight: "22px",
    width: "inherit",
    height: "inherit"
  },
  payment: {
    backgroundColor: "#bfd730",
    borderRadius: "6px 6px 0 0",
    fontWeight: "600",
    fontSize: "12px",
    minWidth: "unset",
    padding: "6px 10px",
    "&:hover": {
      backgroundColor: "#bfd730"
    }
  },
  avator: {
    width: "50px",
    height: "34px",
    marginRight: '10px',
    borderRadius: 0,
    "& img": {
      objectFit: "contain"
    }
  },
}));

const AppInstallBanner = ({ closeBtn, style, className, icon }) => {
  const styles = useStyles();
  const [, , , hideInstallBannerCb, installPWA] = useServiceWorker();
  return (
    <section
      className={className}
      style={{
        backgroundColor: "#f2f2f2",
        display: "flex",
        alignItems: "center",
        padding: "6px 10px",
        height: 'inherit',
        ...style
      }}
    >
      {closeBtn && (
        <IconButton
          aria-label="back button"
          classes={{ root: styles.closeBtn }}
          onClick={hideInstallBannerCb}
        >
          <Icon className={styles.closeIcon}>close</Icon>
        </IconButton>
      )}
      <div
        style={{
          padding: "0 6px",
          marginLeft: "10px",
          flex: 1,
          fontSize: "13px",
          display: 'flex',
          alignItems: 'center'
        }}
      >
        {icon && (
          <figure style={{margin: 0}}>
            <Avatar
              src="/images/payment/neuu_wallet.png"
              classes={{ root: styles.avator }}
            ></Avatar>
          </figure>
        )}
        <section>
          <header>VendingBuddy</header>
          <div style={{ fontSize: "12px", fontWeight: 400 }}>
            Install for a better experience
          </div>
        </section>
      </div>
      <Button variant="contained" classes={{ root: styles.payment }} 
        onClick={installPWA}>
        Install
      </Button>
    </section>
  );
};

AppInstallBanner.propTypes = {
  closeBtn: PropTypes.bool.isRequired,
  style: PropTypes.object.isRequired,
  className: PropTypes.string,
  icon: PropTypes.bool.isRequired
};

AppInstallBanner.defaultProps = {
  closeBtn: true,
  style: {},
  className: "",
  icon: false
};

export default AppInstallBanner;
